import { Navigate, useLocation } from 'react-router-dom';
import { useAuth } from '@/hooks/useAuth';
import { AUTH_STATE, ROUTE_ALIASES } from '@/types';
import { MainLayout } from '..';
import { Flex, Loader } from '@mantine/core';

export const ProtectedRoute = () => {
  const { state } = useAuth();
  const location = useLocation();

  if (state === AUTH_STATE.LOADING) {
    return (
      <Flex h="100vh" w="100vw" justify="center" align="center">
        <Loader size="lg" />
      </Flex>
    );
  }

  if (state === AUTH_STATE.UNAUTHENTICATED) {
    return <Navigate to={ROUTE_ALIASES.LOGIN} state={{ from: location }} replace />;
  }

  return <MainLayout />;
};
